<script setup>
import ModalView from '@/components/common/ModalView.vue'
import { ref, computed } from 'vue'
import OpenCardComponent from './cards/OpenCardComponent.vue';
import { useRoomStore } from '@/stores/room'

const roomStore = useRoomStore()
const cardsString = ref(roomStore.cards.join(','))
const emit = defineEmits(['close'])

const cards = computed(() => {
    return cardsString.value.split(',')
        .map(card => card.trim())
        .filter(Boolean)
})

const error = computed(() => {
    if (cards.value.length === 0) {
        return 'Please enter at least one card'
    }

    if(cards.value.length > 20){
        return 'Cannot have more than 20 cards'
    }

    if(cards.value.some(card => [...card].length > 3)) {
        return 'Card cannot have more than 3 characters'
    }
    return null
})

function onConfirm() {
    roomStore.updateCards(cards.value)
    emit('close')
}
</script>

<template>
    <ModalView label="Customize cards" :confirm="!error" @confirm="onConfirm" @close="emit('close')">
        <input type="text" class="w-full bg-surface-secondary rounded-lg text-neutral py-4 pl-4 text-lg focus:border-primary outline-none focus:outline-accent" placeholder=" 1, 2, 3, 5, 8, 13, 21" v-model="cardsString" />
        <div v-if="error" class="text-sm text-red-500">{{ error }}</div>
        <div v-else class="text-sm text-gray-500">Use commas to separate the cards.</div>
        <div class="mt-4 text-neutral">Preview</div>
        <div class="flex flex-row flex-wrap gap-4 mt-2 bg-surface-secondary p-4 rounded-lg">
            <OpenCardComponent v-for="card in cards" :key="card">{{ card }}</OpenCardComponent>
        </div>
    </ModalView>
</template>
